// Cálculos del calendario. Las fechas viajan como "YYYY-MM-DD" (ver
// utils/fechasLocales): así ningún día se corre por la zona horaria.

import { hoyLocal, sumarDias } from "utils/fechasLocales";

export const DIAS_SEMANA = ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"];
export const DIAS_SEMANA_INICIAL = ["L", "M", "M", "J", "V", "S", "D"];

const MESES = [
  "enero", "febrero", "marzo", "abril", "mayo", "junio",
  "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre",
];

const aUtc = (fecha) => {
  const [anio, mes, dia] = String(fecha).split("-").map(Number);
  return new Date(Date.UTC(anio, mes - 1, dia));
};

const conCero = (numero) => String(numero).padStart(2, "0");

/** { anio, mes } con mes de 1 a 12. */
export const mesDe = (fecha = hoyLocal()) => {
  const [anio, mes] = String(fecha).split("-").map(Number);
  return { anio, mes };
};

export const moverMes = ({ anio, mes }, delta) => {
  const total = anio * 12 + (mes - 1) + delta;
  return { anio: Math.floor(total / 12), mes: (total % 12) + 1 };
};

export const primerDiaDelMes = ({ anio, mes }) => `${anio}-${conCero(mes)}-01`;

export const tituloMes = ({ anio, mes }) => `${MESES[mes - 1].charAt(0).toUpperCase()}${MESES[mes - 1].slice(1)} ${anio}`;

/** 0 = lunes ... 6 = domingo. La semana empieza el lunes, como en Colombia. */
export const diaDeLaSemana = (fecha) => (aUtc(fecha).getUTCDay() + 6) % 7;

/**
 * Las seis semanas que se pintan: desde el lunes de la semana del día 1. Seis
 * siempre, para que la cuadrícula no cambie de alto al pasar de mes.
 */
export const diasDeLaCuadricula = (mes) => {
  const primero = primerDiaDelMes(mes);
  const inicio = sumarDias(primero, -diaDeLaSemana(primero));
  return Array.from({ length: 42 }, (_, indice) => sumarDias(inicio, indice));
};

export const rangoDeLaCuadricula = (mes) => {
  const dias = diasDeLaCuadricula(mes);
  return { desde: dias[0], hasta: dias[dias.length - 1] };
};

export const esDelMes = (fecha, { anio, mes }) => fecha.startsWith(`${anio}-${conCero(mes)}-`);

/** "sábado 24 de octubre" */
export const nombreLargoDelDia = (fecha) => {
  const dias = ["lunes", "martes", "miércoles", "jueves", "viernes", "sábado", "domingo"];
  const [, mes, dia] = String(fecha).split("-").map(Number);
  return `${dias[diaDeLaSemana(fecha)]} ${dia} de ${MESES[mes - 1]}`;
};

/** Actividades por día, en el orden en que llegan (fecha y hora). */
export const agruparPorFecha = (actividades) => {
  const porFecha = new Map();
  for (const actividad of actividades) {
    if (!actividad.fecha) continue;
    const lista = porFecha.get(actividad.fecha) ?? [];
    lista.push(actividad);
    porFecha.set(actividad.fecha, lista);
  }
  return porFecha;
};

/**
 * El punto que lleva cada día: rojo si quedó algo sin hacer en un día que ya
 * pasó, azul si hay pendientes, verde si todo se hizo.
 */
export const estadoDelDia = (actividades = [], fecha, hoy = hoyLocal()) => {
  if (!actividades.length) return null;
  const pendientes = actividades.filter((actividad) => !actividad.completada);
  if (!pendientes.length) return "hecha";
  return fecha < hoy ? "vencida" : "pendiente";
};

export const COLOR_ESTADO_DIA = { vencida: "red.400", pendiente: "blue.400", hecha: "green.400" };
